module.exports = __webpack_public_path__ + "img/phone.7498c51c.svg";